import React from "react";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";

function ScoreTag({ value }: Props) {
  return (
    <div
      className={classNames(styles.tag, {
        [styles.positiveTag]: value > 0,
        [styles.negativeTag]: value < 0,
      })}
    >
      {value}
    </div>
  );
}

export { ScoreTag };
